import { useMemo } from "react";

import { convertSortObjToString } from "./useTableQueryParams";

import { TFinalSort } from "components/Table/types";

export const useSort = (
  sort: Record<string, TFinalSort>,
  multiSort?: boolean
) => {
  const constructedSort = useMemo(() => {
    return convertSortObjToString(sort, multiSort);
  }, [sort, multiSort]);

  return constructedSort;
};
